import { useParams } from "react-router-dom";
import PrepareBillingForm from "./PrepareBillingForm";

export default function ViewPrepareBilling() {
  const { prepareBillingId } = useParams();
  return <PrepareBillingForm viewMode prepareBillingId={prepareBillingId} />;
}
